const cities = [
  { name: "Hollywood", zips: "33019" },
  { name: "Pembroke Pines", zips: "33024" },
  { name: "Davie", zips: "33314" },
  { name: "Miramar", zips: "33023" },
  { name: "Hallandale Beach", zips: "33009" },
  { name: "Fort Lauderdale", zips: "33301" },
  { name: "Cooper City", zips: "33328" },
  { name: "Weston", zips: "33326" },
];

const benefits = [
  {
    icon: "ri-computer-line",
    title: "Start 100% Online",
    desc: "No office visit required to begin. Complete your order from home or work in minutes.",
  },
  {
    icon: "ri-truck-line",
    title: "Ship Your Documents",
    desc: "Use overnight shipping to send your documents directly to us — we handle the rest.",
  },
  {
    icon: "ri-shield-check-line",
    title: "Expert Document Review",
    desc: "Every application is reviewed by our team before submission to reduce errors and delays.",
  },
  {
    icon: "ri-calendar-check-line",
    title: "Reserved Agency Access",
    desc: "We hold reserved submission slots at the regional passport agency — no public appointment needed.",
  },
];

export default function HollywoodLocalAreaSection() {
  return (
    <section id="service-area" className="bg-[#F7F8FA] py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center mb-14">
          <p className="text-[#F6C344] text-xs font-bold uppercase tracking-[0.2em] mb-3">Service Area</p>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#1A365D] mb-4">
            Serving Hollywood &amp; South Broward County
          </h2>
          <p className="text-gray-500 max-w-2xl mx-auto text-base leading-relaxed">
            Whether you are along the Hollywood Beach Broadwalk, near Young Circle, in Pembroke Pines, or anywhere in south Broward County, Fast Passport Center makes expedited passport processing simple — no drive to Miami, no agency lines, no guessing.
          </p>
        </div>

        {/* Full-width editorial intro */}
        <div className="bg-white rounded-lg border border-gray-200 p-6 md:p-8 mb-12">
          <p className="text-gray-600 text-sm leading-relaxed mb-4">
            Hollywood, Florida sits at one of the most strategically positioned points in South Florida — directly between Fort Lauderdale and Miami, with Fort Lauderdale-Hollywood International Airport literally bearing the city&apos;s name. Founded in 1925 by Joseph W. Young, who envisioned a &ldquo;Motion Picture Colony&rdquo; modeled after the California original, Hollywood has evolved into a diverse coastal city of approximately 150,000 residents with a character all its own. The city stretches from the Atlantic Ocean across the Intracoastal Waterway into western Broward County, creating distinct neighborhoods with entirely different travel patterns and demographics.
          </p>
          <p className="text-gray-600 text-sm leading-relaxed mb-4">
            The Hollywood Beach Broadwalk remains one of the most iconic beachfront promenades in the United States — a 2.5-mile brick-paved walkway along turquoise waters, lined with boutique hotels, casual restaurants, and a steady stream of tourists from across the Americas. The Broadwalk attracts beach vacationers, cruise passengers extending their trips, and snowbirds who rent condos along the oceanfront for the winter season. For these travelers, a passport is often needed on short notice — a last-minute cruise booking, an impromptu Bahamas weekend, or a family emergency abroad.
          </p>
          <p className="text-gray-600 text-sm leading-relaxed mb-4">
            Downtown Hollywood centers around Young Circle and the ArtsPark at Young Circle, a ten-acre outdoor amphitheater and cultural venue that anchors one of South Florida&apos;s most vibrant arts districts. The Downtown Hollywood Mural Project has transformed building walls into an open-air gallery, while the ArtsPark hosts concerts, festivals, and community gatherings that draw visitors from across Broward and Miami-Dade counties. The downtown arts corridor attracts creative professionals, musicians, and performers who travel internationally for exhibitions, residencies, tours, and competitions — often with tight deadlines that do not accommodate standard passport processing.
          </p>
          <p className="text-gray-600 text-sm leading-relaxed mb-4">
            West of downtown, Hollywood extends into residential neighborhoods, commercial corridors along Sheridan Street and Stirling Road, and the sprawling West Lake Park and Anne Kolb Nature Center — a 1,500-acre coastal mangrove preserve that represents one of the largest urban wilderness areas in Florida. The western neighborhoods of Hollywood include a substantial Latin American population, particularly Colombian, Cuban, Dominican, Venezuelan, and Brazilian communities whose family and business ties create constant international travel demand. These travelers frequently need passports for family visits, business meetings, cultural events, and educational exchanges — trips that are often booked with limited advance notice.
          </p>
          <p className="text-gray-600 text-sm leading-relaxed mb-4">
            Hollywood&apos;s proximity to Fort Lauderdale-Hollywood International Airport (FLL) is arguably the single greatest travel advantage of any city in South Florida. Located just five to ten minutes from most Hollywood neighborhoods, FLL is a major hub for Southwest, JetBlue, and Spirit Airlines with direct service to the Caribbean, Mexico, Central America, and major U.S. cities. Port Everglades, one of the world&apos;s busiest cruise ports, sits just fifteen to twenty minutes north via I-595 and US-1, making Hollywood one of the most convenient embarkation cities for Caribbean cruises. Miami International Airport (MIA) is roughly twenty-five to thirty minutes south via I-95, providing additional international routes and long-haul connections.
          </p>
          <p className="text-gray-600 text-sm leading-relaxed">
            Fast Passport Center has processed expedited passports for Hollywood travelers across every neighborhood and travel scenario — from beachfront condo residents booking last-minute cruises to downtown arts professionals heading to European exhibitions to western Hollywood families visiting relatives in Colombia. Our courier-based expedited service means you start online from your Broadwalk apartment, your Young Circle loft, or your Sheridan Street home — and your passport arrives within days, not months. No drive to the Miami Passport Agency. No hoping a standard application clears in time. Just a reliable, predictable process that works around your schedule.
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-start">
          {/* Left — FPC Office + How It Works */}
          <div>
            {/* FPC Office Card */}
            <div className="bg-[#1A365D] rounded-lg p-7 mb-8 text-white">
              <div className="flex items-center gap-3 mb-5">
                <div className="w-11 h-11 flex items-center justify-center rounded-full bg-[#F6C344] flex-shrink-0">
                  <i className="ri-building-2-line text-[#1A365D] text-xl"></i>
                </div>
                <div>
                  <p className="font-bold text-base">Fast Passport Center — Delray Beach</p>
                  <p className="text-white/60 text-xs mt-0.5">401 W Atlantic Ave #351, Delray Beach, FL 33444</p>
                </div>
              </div>
              <p className="text-white/70 text-sm mb-1">
                <i className="ri-map-pin-line text-[#F6C344] mr-1.5"></i>
                Nearest office to Hollywood — approximately 35 miles north on I-95
              </p>
              <p className="text-white/50 text-xs mb-5 ml-5">Courier pickup available throughout Broward County</p>
              <div className="border-t border-white/10 pt-5">
                <p className="text-white/80 text-sm leading-relaxed mb-4">
                  After signing up online, choose what works best for you: <strong className="text-white">courier pickup</strong> from your home or office in most cases, <strong className="text-white">ship with our prepaid label</strong> from any UPS/FedEx location, or <strong className="text-white">schedule a drop-off</strong> at our Delray Beach office. Most clients ship overnight — no visit required.
                </p>
                <a
                  href="https://fastpassportcenter.com/checkout/"
                  className="inline-flex items-center gap-2 bg-[#F6C344] hover:bg-[#e5b430] text-[#1A365D] font-bold text-sm px-5 py-2.5 rounded-md transition-all whitespace-nowrap"
                >
                  Start My Passport <i className="ri-arrow-right-line"></i>
                </a>
              </div>
            </div>

            {/* How FPC Helps */}
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
              {benefits.map((b, i) => (
                <div key={i} className="bg-white rounded-lg p-5 border border-gray-200">
                  <div className="w-9 h-9 flex items-center justify-center rounded-full bg-[#F6C344]/15 mb-3">
                    <i className={`${b.icon} text-[#1A365D] text-base`}></i>
                  </div>
                  <p className="font-bold text-[#1A365D] text-sm mb-1">{b.title}</p>
                  <p className="text-gray-500 text-xs leading-relaxed">{b.desc}</p>
                </div>
              ))}
            </div>
          </div>

          {/* Right — Cities We Serve + Trust strip */}
          <div>
            <div className="bg-white rounded-lg p-7 mb-6 border border-gray-200">
              <h3 className="font-bold text-[#1A365D] text-sm uppercase tracking-wide mb-5">
                <i className="ri-map-pin-2-line text-[#F6C344] mr-2"></i>
                Cities &amp; Communities We Serve
              </h3>
              <div className="space-y-1.5">
                {cities.map((city, i) => (
                  <div
                    key={i}
                    className="flex items-center justify-between py-2.5 px-3 bg-[#F7F8FA] rounded-md"
                  >
                    <div className="flex items-center gap-2.5">
                      <i className="ri-checkbox-circle-fill text-[#F6C344] text-sm"></i>
                      <span className="text-[#1A365D] font-medium text-sm">{city.name}</span>
                    </div>
                    {city.zips && (
                      <span className="text-gray-400 text-xs font-mono">{city.zips}</span>
                    )}
                  </div>
                ))}
              </div>
              <p className="text-gray-500 text-xs mt-4 leading-relaxed">
                Anywhere in south Broward County — start online, ship overnight, and we handle the rest. No need to drive to Miami.
              </p>
            </div>

            {/* Internal links */}
            <div className="bg-white rounded-lg p-5 mb-6 border border-gray-200">
              <p className="text-gray-400 text-xs font-semibold uppercase tracking-widest mb-3">Nearby Cities We Serve</p>
              <div className="flex flex-wrap gap-2">
                {[
                  { name: "Fort Lauderdale", href: "/fort-lauderdale" },
                  { name: "Miami", href: "/miami" },
                  { name: "Plantation", href: "/plantation" },
                  { name: "Coral Springs", href: "/coral-springs" },
                  { name: "Weston", href: "/weston" },
                  { name: "Aventura", href: "/aventura" },
                ].map((link) => (
                  <a
                    key={link.href}
                    href={link.href}
                    className="inline-flex items-center gap-1 text-xs text-[#1A365D] hover:text-[#F6C344] font-medium transition-colors bg-[#F7F8FA] border border-gray-200 hover:border-[#F6C344] rounded-full px-3 py-1.5 whitespace-nowrap"
                  >
                    {link.name} <i className="ri-arrow-right-line text-[10px]"></i>
                  </a>
                ))}
              </div>
            </div>

            {/* Trust credentials strip */}
            <div className="bg-[#1A365D] rounded-lg p-5">
              <p className="text-white/50 text-xs uppercase tracking-widest font-semibold mb-4">Why Travelers Choose Fast Passport Center</p>
              <div className="grid grid-cols-2 gap-3">
                {[
                  { icon: "ri-government-line", value: "Registered Courier", label: "U.S. Department of State" },
                  { icon: "ri-award-line", value: "A+ Rating", label: "Better Business Bureau" },
                  { icon: "ri-calendar-check-line", value: "20+ Years", label: "Serving Travelers Nationwide" },
                  { icon: "ri-customer-service-2-line", value: "Real Humans", label: "Live Support — Not a Bot" },
                ].map((item, i) => (
                  <a
                    key={i}
                    href="https://fastpassportcenter.com"
                    className="flex items-center gap-2.5 bg-white/5 hover:bg-white/10 rounded-md px-3 py-2.5 transition-colors cursor-pointer"
                  >
                    <div className="w-8 h-8 flex items-center justify-center rounded-full bg-[#F6C344]/15 flex-shrink-0">
                      <i className={`${item.icon} text-sm text-[#F6C344]`}></i>
                    </div>
                    <div className="text-left">
                      <span className="text-white text-xs font-bold block leading-tight">{item.value}</span>
                      <span className="text-white/50 text-xs leading-tight block">{item.label}</span>
                    </div>
                  </a>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}